import * as React from 'react';

function SvgEraseBack(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M18.52 4.5h-7.74C8.6 4.5 7.35 6.13 6 7.48a213.3 213.3 0 00-3.38 3.5 1.47 1.47 0 000 1.96S4.22 14.7 6 16.48c1.77 1.77 2.66 3.02 4.78 3.02h7.74a3.3 3.3 0 003.23-3.32V7.73c0-1.8-1.43-3.23-3.23-3.23zm-.83 9.97c.29.3.29.77 0 1.06a.75.75 0 01-1.06 0l-2.47-2.47-2.47 2.47c-.3.29-.77.3-1.06 0a.72.72 0 010-1.06L13.1 12l-2.47-2.47a.72.72 0 010-1.06.72.72 0 011.06 0l2.47 2.47 2.47-2.47a.75.75 0 011.06 0c.29.3.29.77 0 1.06L15.22 12l2.47 2.47z" />
    </svg>
  );
}

export default SvgEraseBack;
